"use client";
import { kebabCase as b } from "./index.es7.js";
import "react";
import { round as C } from "./index.es8.js";
const ct = (t, e, o, n) => ({
  title: t.title,
  regionsData: o,
  monitorApiUrl: t.monitorApiUrl || e,
  shortDescription: t.shortDescription,
  monitorType: t.monitorType,
  distributionExplanation: t.distributionExplanation,
  indicatorGroups: t.indicatorGroups.map(
    (r) => D(r)
  ),
  slug: n,
  components: t.components
}), O = (t) => t?.indicator ? {
  ...t.indicator,
  //id: indicator.indicator.data.id,
  linkText: t.linkText
} : null, D = (t) => {
  const { description: e, id: o, title: n, slug: r } = t;
  return {
    description: e,
    id: o,
    title: n,
    slug: r,
    indicators: t.indicators.map((a) => O(a)).filter((a) => a)
  };
}, ut = (t) => {
  const e = [
    "Country",
    "Region",
    "County",
    "Municipality",
    "Cooperation",
    "CityPart",
    "CitySubPart",
    "Grouping"
  ], o = e.reduce(
    (s, l) => ({ ...s, [l]: [] }),
    {}
  ), n = {}, r = [], a = (s) => s.regionCode.split(",").map((c) => n[c]), p = (s) => s.type === "Cooperation" || s.type === "Grouping" ? a(s)?.[0]?.parent : s.parentCode ? n[s.parentCode] : null;
  for (const s of e) {
    o[s] = t.filter((c) => c.type === s).sort((c, u) => c.name < u.name ? -1 : 1).map((c) => ({
      ...c,
      parent: p(c),
      ...c.type === "Cooperation" ? { regions: a(c) } : {}
    }));
    const l = o[s].reduce(
      (c, u) => ({ ...c, [u.regionCode]: u }),
      {}
    );
    Object.assign(n, l), r.push(...o[s]);
  }
  for (const s of r)
    s.displayName = T(s);
  return { byType: o, byCode: n, array: r };
}, T = (t) => t.displayName ? t.displayName : ["Country", "Region", "County", "Municipality"].includes(t.type) ? t.name : t.type === "Cooperation" ? `${t.name} (samarbeid)` : t.type === "Grouping" ? `${t.name} (gruppering)` : t.type === "CityPart" && t.parent ? `${t.name} (${t.parent.name})` : t.type === "CitySubPart" && t.parent ? t.parent.parent ? `${t.name} (${t.parent.name}, ${t.parent.parent.name})` : `${t.name} (region.parent.name)` : t.name, j = (t) => t.map((e) => ({
  display: e.displayName || e.name,
  value: e.regionCode
})), pt = (t, e, o = []) => (n) => {
  const r = [], a = n.toLowerCase();
  if (n)
    for (const p of t) {
      const s = e.byType[p].filter((l) => {
        const c = n.length <= 2 ? l.name.toLowerCase().startsWith(a) : l.name.toLowerCase().includes(a), u = !o.some(
          (i) => i.regionCode === l.regionCode
        );
        return c && u;
      });
      r.push(...j(s));
    }
  return r;
}, G = (t, e) => {
  if (!t.parent)
    return [];
  const o = (n, r) => n.regionCode === r.regionCode ? !1 : n.parentCode === r.parentCode;
  return e.array.filter((n) => o(t, n));
}, V = (t) => t.type === "CityPart" || t.type === "CitySubPart" ? t.name : t.displayName || t.name, dt = (t, e) => G(t, e).map((r) => ({
  value: r.regionCode,
  display: V(r)
}));
function ht(t) {
  return [
    "Country",
    "County",
    "Region",
    "Municipality",
    "CityPart",
    "CitySubPart",
    "Cooperation",
    "Grouping"
  ].includes(t);
}
const v = (t, e) => t.parent ? t.parent.type === e ? t.parent : v(t.parent, e) : null, gt = {
  Country: "Norge",
  Region: "Landsdel",
  County: "Fylke",
  Municipality: "Kommune",
  CityPart: "Bydel",
  CitySubPart: "Delbydel",
  Cooperation: "Samarbeid",
  Grouping: "Gruppering"
}, ft = (t) => (e) => (o, n) => {
  const r = v(o, n)?.regionCode;
  return r && t.find((a) => a.indicatorId === e)?.parentRegions?.[r] || null;
}, U = (t) => {
  const e = {
    ...t.regions
  };
  for (const o in t.parentRegions)
    e[o] = t.parentRegions[o].value;
  return e;
}, mt = (t) => {
  const e = t.reduce(
    (o, n) => ({
      ...o,
      [n.indicatorId]: U(n)
    }),
    {}
  );
  return (o, n) => {
    if (e[n]) {
      const a = e[n][o.regionCode];
      if (typeof a == "number")
        return a;
    }
    return null;
  };
}, S = (t) => !t.includes("antall"), _ = (t) => t.includes("husholdning"), B = (t, e) => {
  if (S(t)) {
    const { proportionalUnits: o, proportionalUnitsOverride: n } = e;
    return n || (o === "prosent" ? "%" : o);
  } else {
    const { absoluteUnits: o, absoluteUnitsOverride: n } = e;
    return n || (o === "barn / husholdninger" ? _(t) ? "husholdninger" : "barn" : o);
  }
}, yt = (t) => (e, o) => {
  const n = B(t, e);
  let r = S(t) ? 1 : 0;
  return r && e.proportionalUnits === "kr" && (r = 0), typeof o == "number" ? `${Number(o.toFixed(r)).toLocaleString(
    "nb-NO"
  )} ${n}` : "..";
}, bt = (t, e) => {
  const o = t.get("primary"), n = t.getAll("regions"), r = o && e.byCode[o] || null, a = (n || []).map((p) => e.byCode[p]).filter((p) => p && p !== r);
  return { primaryRegion: r, otherRegions: a };
}, Ct = (t, e) => t.primaryRegion === e.primaryRegion && t.otherRegions.length === e.otherRegions.length ? t.otherRegions.every((o, n) => o === e.otherRegions[n]) : !1, wt = (t = !0) => `${t ? "?" : ""}${new URL(
  document.location.toString()
).searchParams.toString()}`, H = (t) => [
  ...new Set(t.map((e) => Object.keys(e.values)).flat())
].sort(), Rt = (t, e, o, n) => {
  const r = n === "Absolute" ? (l) => C(l, 0) : (l) => C(l, 1), a = o ? [o] : H(t), p = t.map(
    (l) => e.byCode[l.regionCode].name
  );
  return {
    datasets: t.map((l, c) => ({
      label: p[c],
      name: p[c],
      data: a.map(
        (u) => typeof l.values[u] != "number" ? ".." : r(l.values[u] || 0)
      )
    })),
    labels: a,
    names: p
  };
}, $t = (t, e, o) => {
  const n = o ? "%" : "", r = t.map(
    (a) => typeof a.value == "number" ? `${a.low}-${a.high}${n}` : ""
  );
  return {
    labels: r,
    names: [...r],
    datasets: [
      {
        label: e,
        name: e,
        fill: "origin",
        data: t.map((a) => a.value)
      }
    ]
  };
}, m = (t, e) => {
  const o = e.findIndex((n) => t >= n.low && t < n.high);
  if (o >= 0) {
    const n = e[o].high - e[o].low, r = e[o].high - n / 2, a = (t - r) / (2 * (e[o].high - r));
    return o + a;
  } else if (t < e[0].low) {
    const n = {
      low: 2 * e[0].low - e[0].high,
      high: e[0].low,
      value: 0
    };
    return m(t, [n, ...e]) - 1;
  } else if (t > e[e.length - 1].high) {
    const n = {
      low: e[e.length - 1].high,
      high: 2 * e[e.length - 1].high - e[e.length - 1].low,
      value: 0
    };
    return m(t, [...e, n]);
  }
  return 0;
}, Q = (t, e) => e.findIndex((n) => n.low <= t && n.high > t) > e.length - 3, q = (t, e) => t && t.length ? e.map((o) => ({
  ...o,
  x: m(o.value, t),
  labelLeft: Q(o.value, t)
})) : [], vt = (t, e, o) => q(t, e.selected).map((n) => ({
  ...n,
  name: o.byCode[n.regionCode].name,
  suffix: e.categories?.includes("andel") ? "%" : ""
})), A = (t, e, o) => {
  if (e < 1 || !t.length)
    return t;
  const n = [
    { value: null, low: t[0].low - o, high: t[0].low },
    ...t
  ];
  return e < 2 ? n : A(n, e - 1, o);
}, I = (t, e, o) => {
  if (e < 1 || !t.length)
    return t;
  const n = [
    ...t,
    {
      value: null,
      low: t[t.length - 1].high,
      high: t[t.length - 1].high + o
    }
  ];
  return e < 2 ? n : I(n, e - 1, o);
}, St = (t) => {
  const { ranges: e, selected: o } = t;
  if (!e || !e.length)
    return [];
  if (!o || !o.length)
    return e;
  const n = e[0].low, r = e[e.length - 1].high, a = e[0].high - e[0].low, p = n + a / 2, s = r - a / 2, l = o.reduce(
    (i, d) => Math.min(i, d.value),
    Number.MAX_VALUE
  ), c = o.reduce(
    (i, d) => Math.max(i, d.value),
    Number.MIN_VALUE
  );
  let u = [...e];
  if (l < p) {
    const i = Math.ceil(
      (p - l) / a
    );
    u = A(
      u,
      i,
      a
    );
  }
  if (c > s) {
    const i = Math.ceil(
      (c - s) / a
    );
    u = I(
      u,
      i,
      a
    );
  }
  return u;
}, Y = Intl.NumberFormat("no-nb"), f = ["rgba(91,29,230,0.6)", "rgba(95,63,107,0.6)"], w = ["rgba(91,29,230,1)", "rgba(95,63,107,1)"], R = (t) => (e) => {
  const o = e.chart, n = o.options?.plugins?.annotation?.annotations;
  if (n) {
    const r = n[`line${t}`];
    "borderColor" in r && (r.borderColor = f[t % 2]);
    const a = n[`label${t}`];
    "backgroundColor" in a && (a.backgroundColor = f[t % 2]);
  }
  return o.update(), !0;
}, $ = (t) => (e) => {
  const o = e.chart, n = o.options?.plugins?.annotation?.annotations;
  if (n) {
    const r = n[`line${t}`];
    "borderColor" in r && (r.borderColor = w[t % 2]);
    const a = n[`label${t}`];
    "backgroundColor" in a && (a.backgroundColor = w[t % 2]);
  }
  return o.update(), !0;
}, z = (t, e) => {
  const o = (p) => (s) => {
    const l = s?.chart?.scales?.y?.max || 100, c = s.element, { chart: u } = s;
    if (c && c.height) {
      const i = u.height;
      return l - l * 40 * p / i;
    }
    return l;
  }, n = Y.format(
    Number((t.value || 0).toFixed(1))
  ), r = t.labelLeft;
  return {
    [`line${e}`]: {
      type: "line",
      leave: R(e),
      enter: $(e),
      xMin: t.x,
      xMax: t.x,
      borderColor: f[e % 2],
      borderWidth: 3,
      borderDash: [7, 4]
    },
    [`label${e}`]: {
      type: "label",
      z: 1,
      leave: R(e),
      enter: $(e),
      xValue: t.x,
      yValue: o(e),
      position: r ? { x: "end", y: "start" } : "start",
      content: `${t.name} ${n}${t.suffix}`,
      // format value with units
      backgroundColor: f[e % 2],
      color: "#FFFFFF",
      font: {
        size: 12
      },
      borderRadius: {
        topLeft: r ? 16 : 0,
        topRight: r ? 0 : 16,
        bottomLeft: r ? 16 : 0,
        bottomRight: r ? 0 : 16
      },
      padding: {
        left: r ? 8 : 16,
        right: r ? 16 : 8,
        top: 5,
        bottom: 5
      }
    }
  };
}, At = (t, e) => {
  const o = {
    annotations: {}
  };
  for (let n = 0; n < e.length; n++)
    o.annotations = {
      ...o.annotations,
      ...z(e[n], n)
    };
  t.plugins = { ...t.plugins, annotation: o };
}, W = (t) => t.primaryRegion?.regionCode ? [
  t.primaryRegion.regionCode,
  ...t.otherRegions.map((e) => e.regionCode)
] : [], X = (t, e) => {
  if (t.includeLink) {
    if (t.__component === "common.accordions-block")
      return t.accordions.map((o, n) => ({
        hash: `${b(o.title)}-${e}-${n}`,
        display: o.title,
        componentId: o.id,
        componentType: "accordion"
      }));
    if (t.__component === "common.text-block")
      return [
        {
          display: t.title,
          hash: `${b(t.title)}`,
          componentId: t.id,
          componentType: "text"
        }
      ];
  }
  return [];
}, It = (t) => {
  const e = [];
  return t && Array.isArray(t) && t.forEach((o, n) => {
    e.push(...X(o, n));
  }), e;
}, Ft = (t) => async (e, o, n, r) => {
  const a = W(e), p = `indicatorId=${o}&${a.map((u) => `regionCode=${u}`).join("&")}&${r.map((u) => `categories=${u}`).join("&")}&year=${n}`, s = `${t}/indicator-data/distribution?${p}`, l = await fetch(s);
  if (l.ok)
    return {
      ...await l.json(),
      categories: r,
      indicatorId: o,
      year: n
    };
  throw await l.json();
}, Pt = (t, e, o) => ({
  data: e.map(
    (n) => K(t, n, o)
  ),
  sheets: e.map(
    (n, r) => (n.title || `Ark${r}`).substring(0, 30)
  )
}), K = (t, e, o) => {
  const n = e.indicators.flatMap((r) => [
    [],
    ...J(t, r, o)
  ]);
  return [[{ type: String, value: e.title }], ...n];
}, J = (t, e, o) => {
  const n = t.filter(
    (i) => i.indicatorId === e.indicatorApiId
  ), r = (i, d) => (Object.keys(d).forEach((g) => i.add(g)), i), a = Array.from(
    n.map((i) => i.values).reduce(r, /* @__PURE__ */ new Set())
  ).sort(), p = (i) => {
    const { categories: d, regionCode: g } = i, N = d.includes("antall") ? "# ##0" : "# ##0.0", h = [], k = o.byCode[g].displayName || o.byCode[g].name;
    return h.push({ type: String, value: g }), h.push({ type: String, value: k }), i.categories.length > 1 && h.push({ type: String, value: i.categories[1] }), h.push({ type: String, value: i.categories[0] }), a.forEach((E) => {
      const y = i.values[E];
      typeof y == "number" ? h.push({ type: Number, value: y, format: N }) : h.push({ type: String, value: ".." });
    }), h;
  }, s = t.filter((i) => i.indicatorId === e.indicatorApiId).sort((i, d) => i.categories.includes("antall") && !d.categories.includes("antall") ? -1 : !i.categories.includes("antall") && d.categories.includes("antall") ? 1 : i.categories.includes("barn") && !d.categories.includes("barn") ? -1 : !i.categories.includes("barn") && d.categories.includes("barn") ? 1 : 0), l = [[{ type: String, value: e.title }], []], c = [];
  if (n.length) {
    const i = n[0].categories;
    c.push(
      { type: String, value: "Id" },
      { type: String, value: "Sted" },
      { type: String, value: "Målenhet" }
    ), i.length > 1 && c.push({ type: String, value: "Enhet" }), a.forEach((d) => c.push({ type: String, value: d }));
  }
  const u = s.map((i) => p(i));
  return [...l, c, ...u];
}, F = (t) => {
  const e = t.indicatorIds.map((n) => `indicatorIds=${n}`).join("&"), o = t.regionCodes.map((n) => `regionCode=${n}`).join("&");
  return `${e}&${o}`;
}, Z = (t) => `${F(t)}&${t.categories.map((e) => `categories=${e}`).join("&")}`, xt = (t) => async (e) => {
  if (!(e?.indicatorIds?.length && e?.regionCodes?.length))
    return [];
  const o = `${t}/indicator-data/detailsmultiple?${F(
    e
  )}`, n = await fetch(o);
  if (n.ok)
    return n.json();
  throw await n.json();
}, Mt = (t) => t.flatMap((e) => e.indicators), tt = (t) => async (e) => {
  if (!(e?.indicatorIds?.length && e?.regionCodes?.length))
    return [];
  const o = `${t}/indicator-data/overview?${Z(
    e
  )}`, n = await fetch(o);
  if (n.ok)
    return (await n.json()).map((p) => ({ ...p, categories: [...e.categories] }));
  throw await n.json();
}, et = (t) => t === "ChildPoverty" ? [
  { categories: ["barn", "prosent"] },
  { categories: ["barn", "antall"] },
  { categories: ["husholdning", "prosent"] },
  { categories: ["husholdning", "antall"] }
] : [{ categories: ["andel"] }, { categories: ["antall"] }], Lt = (t, e) => async (o) => {
  const n = tt(t);
  return (await Promise.all(
    et(e).map(
      (a) => n({ ...o, ...a })
    )
  )).flatMap((a) => a);
}, nt = (t, e) => t.length === e.length && t.every((o, n) => e[n] === o), P = (t) => Array.isArray(t) ? t.length < 2 ? t.includes("antall") ? "antall" : "andel" : t.includes("husholdning") ? t.includes("antall") ? "husholdning-antall" : "husholdning-prosent" : t.includes("antall") ? "barn-antall" : "barn-prosent" : "andel", ot = {
  andel: ["andel"],
  antall: ["antall"],
  "barn-antall": ["barn", "antall"],
  "barn-prosent": ["barn", "prosent"],
  "husholdning-antall": ["husholdning", "antall"],
  "husholdning-prosent": ["husholdning", "prosent"]
}, rt = {
  andel: "Andel",
  antall: "Antall",
  "barn-antall": "Antall barn",
  "barn-prosent": "Prosent barn",
  "husholdning-antall": "Antall husholdning",
  "husholdning-prosent": "Prosent husholdning"
}, Nt = (t) => ot[t], x = (t) => Array.isArray(t) ? x(P(t)) : rt[t], M = (t) => t.reduce(
  (e, o) => e.find((n) => nt(n, o.categories)) ? e : [...e, o.categories],
  []
), at = (t) => t.sort(L).map((e) => {
  const o = P(e);
  return {
    value: o,
    label: x(o)
  };
}), kt = (t) => at(M(t)), L = (t, e) => t.includes("husholdning") && !e.includes("husholdning") ? 1 : !t.includes("husholdning") && e.includes("husholdning") ? -1 : t.includes("antall") && !e.includes("antall") ? 1 : !t.includes("antall") && e.includes("antall") ? -1 : 0, Et = (t) => {
  const e = M(t).sort(
    L
  );
  return e.length ? e[0] : [];
};
export {
  gt as GeoTypeNames,
  At as addAnnotationOptions,
  M as categoriesFromDetails,
  L as categoriesSortCompare,
  at as categoryOptionsFromCategoriesList,
  kt as categoryOptionsFromDetails,
  $t as chartDataForNullableValueRanges,
  Rt as chartDataForRegionsByYear,
  pt as createChoicesGenerator,
  It as createComponentsLinks,
  Lt as createFetchAllMonitorApiIndicatorValues,
  Ft as createFetchDistribution,
  xt as createFetchMonitorApiIndicatorDetails,
  tt as createFetchMonitorApiIndicatorValues,
  mt as createFindIndicatorValue,
  yt as createFormatter,
  wt as currentQueryParamsString,
  St as extendedRanges,
  v as findAncestorOfType,
  Mt as flattenIndicatorGroups,
  dt as generatePeerChoices,
  Et as getCategoriesDefault,
  et as getCategoriesParams,
  T as getDisplayName,
  ft as getParentMinMaxValue,
  G as getPeers,
  nt as isArrayEqual,
  ht as isGeoType,
  Ct as isRegionSelectionEqual,
  W as regionCodesFromRegionSelection,
  bt as regionsFromParams,
  Nt as toCategories,
  x as toCategoriesLabel,
  P as toCategoriesString,
  j as toChoiceList,
  J as toExcelIndicatorData,
  K as toExcelIndicatorGroupData,
  Pt as toExcelIndicatorGroupsData,
  D as toIndicatorGroupProps,
  O as toIndicatorProps,
  ct as toMonitorProps,
  vt as toNamedDistributionValues,
  q as toRegionDistributionValues,
  ut as toRegionsData,
  U as toValuesByRegionCode,
  H as yearsFromRegionYearValues
};
//# sourceMappingURL=index.es4.js.map
